//import destinations from '../data/destinations';
//import ArticleItem from '../components/ArticleItem';
import '../styles/travel.scss';
import WorldMap from '../components/WorldMap';
import usePageTitle from '../hooks/usePageTitle';

function Travel() {
  usePageTitle('World Map | Dochano')
  return (
    <section className="travel-container">
      <div id="Intro">
          <h1>World Map</h1>
      </div>
      <WorldMap />

      {/*destinations.map(destination => (
        <ArticleItem key={destination.id} info={destination} />
      ))*/}
      
    </section>
  );
}

export default Travel;